import React from "react"
import { FloatingActionButton, Paper, Toggle } from "material-ui"
import ContentAdd from "material-ui/svg-icons/content/add"
import autobind from "class-autobind"
import strings from "../../../localization/strings"
import { ISchedulePatternTemplate, IWorkPoolEmployee } from "../../../models"
import AuthenticationStore from "../../../stores/AuthenticationStore"
import TableActionBar from "../../layout/TableActionBar"
import ShiftWorkPoolEmployeeTable from "./ShiftWorkPoolEmployeeTable"
import ShiftAddShortListedCandidate from "./ShiftAddShortListedCandidate"

interface IProps {
    readonly?: boolean
    assignPatternTemplate: ISchedulePatternTemplate
    shortListCandidates: IWorkPoolEmployee[]
    archiveCandidate(employeeId: string): void
    updateWorkPoolEmployeesList(workPoolEmployees: IWorkPoolEmployee[]): void    
    handleChooseEmployee(employee: IWorkPoolEmployee): void
    assignEmployeeToShift: (employee: IWorkPoolEmployee) => void
    replaceSchedulePatternTemplate(schedulePatternTemplate: ISchedulePatternTemplate): void
}
interface IState {
    shortListCandidates: IWorkPoolEmployee[]
    selectedShortListCandidates: IWorkPoolEmployee[]
    openAddShortlistDialog: boolean
    offset: number
    limit: number
    showArchived: boolean
}

export default class ShiftCandidateShortList extends React.Component<IProps, IState> {
    constructor(props) {
        super(props)
        this.state = {
            shortListCandidates: props.shortListCandidates,
            selectedShortListCandidates: [],
            openAddShortlistDialog: false,
            offset: 0,
            limit: 20,
            showArchived: true
        }
        autobind(this)
    }

    componentWillReceiveProps(newProps) {
        if (this.props.shortListCandidates !== newProps.shortListCandidates) {
            this.setState({ shortListCandidates: newProps.shortListCandidates })
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.shortListCandidates !== prevProps.shortListCandidates) {
            if (!this.state.showArchived) {
                const shortListCandidates = this.state.shortListCandidates.slice().filter(item => !item.ArchivedByUserIds.includes(AuthenticationStore.getLoggedInUser().Id))
                this.setState({ shortListCandidates })
            } else {
                this.setState({ shortListCandidates: this.props.shortListCandidates })
            }
        }
    }

    render() {
        const viewableEmployees = this.state.shortListCandidates.slice(this.state.offset, Math.min(this.state.offset + this.state.limit, this.state.shortListCandidates.length))
        return (
            <Paper zDepth={1} style={{ marginBottom: 50 }}>
                <div style={{ position: "relative" }}>
                    {!this.props.readonly &&
                        <FloatingActionButton
                            className="fixed-add"
                            style={{ right: 50, top: -30, zIndex: 998 }}
                            secondary
                            onTouchTap={() => this.setState({ openAddShortlistDialog: true })}>
                            <ContentAdd />
                        </FloatingActionButton>
                    }
                    <div style={{ fontSize: 15, fontWeight: "bold", padding: 25 }}>
                        {strings.My_Candidate_ShortList}
                    </div>
                    {this.props.shortListCandidates.length !== 0 &&
                        <Toggle
                            onToggle={(e, checked) => {
                                this.setState({ showArchived: checked }, () => {
                                    if (!this.state.showArchived) {
                                        const shortListCandidates = this.state.shortListCandidates.slice().filter(item => !item.ArchivedByUserIds.includes(AuthenticationStore.getLoggedInUser().Id))
                                        this.setState({ shortListCandidates })
                                    } else {
                                        this.setState({ shortListCandidates: this.props.shortListCandidates })
                                    }
                                })
                            }}
                            style={{ width: 175, position: "absolute", right: 50, top: 50, paddingBottom: 10, marginTop: -5 }}
                            defaultToggled={this.state.showArchived}
                            label={strings.Show_Archived}
                            labelStyle={{ width: 129, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}
                            disabled={this.props.readonly}
                            title={strings.Show_Archived}
                        />
                    }
                    <TableActionBar
                        searchText={""}
                        rowSelectionCount={this.state.selectedShortListCandidates.length}
                        singleSelectedMessage={strings.Employee_Selected}
                        multipleSelectedMessage={strings.x_Employees_Selected}
                        onAssignSelectedItem={() => this.props.handleChooseEmployee(this.state.selectedShortListCandidates[0])}
                        readonly={this.props.readonly}
                    />
                    <ShiftWorkPoolEmployeeTable
                        tableName={"shortlist"}
                        readonly={this.props.readonly}
                        singleSelectable
                        workPoolEmployees={viewableEmployees}
                        selectedCandidates={this.state.selectedShortListCandidates}
                        offset={this.state.offset}
                        limit={this.state.limit}
                        limitOptions={[20, 50, 100]}
                        total={this.state.shortListCandidates.length}
                        onPageClick={offset => this.setState({ offset })}
                        onLimitChange={limit => this.setState({ limit, offset: 0 })}
                        archiveCandidate={this.props.archiveCandidate}
                        handleSelectedCandidates={selectedShortListCandidates => this.setState({ selectedShortListCandidates })}
                        assignEmployeeToShift={this.props.assignEmployeeToShift}
                    />
                    <ShiftAddShortListedCandidate
                        assignPatternTemplateId={this.props.assignPatternTemplate.Id}
                        open={this.state.openAddShortlistDialog}
                        onClose={() => this.setState({ openAddShortlistDialog: false })}
                        updateWorkPoolEmployeesList={this.props.updateWorkPoolEmployeesList}
                        replaceSchedulePatternTemplate={this.props.replaceSchedulePatternTemplate}
                    />
                </div>
            </Paper>
        )
    }
}